import { useCallback } from "react";
import { USER_DOT_COM_APP_KEY } from "@config/userDotCom";

type UserComAccountData = {
  id: number;
  email: string;
};

const useUserDotComAuth = () => {
  const apiKey = USER_DOT_COM_APP_KEY;

  const getWidget = useCallback(() => window.UE, []);

  const update = useCallback(
    (account: UserComAccountData) => {
      const widget = getWidget();
      if (!widget) return;

      widget.pageHit({
        apiKey,
        user_id: account.id,
        email: account.email,
        resolution: `${window.screen.availHeight}x${window.screen.availWidth}`,
      });
    },
    [apiKey, getWidget],
  );

  const logoutAPI = useCallback(
    (onLogout: () => void) => {
      const widget = getWidget();
      if (!widget) {
        onLogout();
        return;
      }

      window.civchat = { apiKey };
      widget.resetAuth({ apiKey, onLoad: onLogout });
    },
    [apiKey, getWidget],
  );

  const isChatReady = useCallback(
    () => Boolean(getWidget()?.isReady && window.userengage),
    [getWidget],
  );

  const openChat = useCallback(() => {
    if (!isChatReady()) return false;
    window.userengage?.("widget.show");
    window.userengage?.("widget.open");
    return true;
  }, [isChatReady]);

  return {
    isChatReady,
    logoutAPI,
    openChat,
    update,
  };
};

export default useUserDotComAuth;
